<template>
  <LayoutContainer :props="props">
    <div class="news-container" v-if="news.length">
      <div class="news-cot">
        <ul :class="{ marquee_top: animate  }" :style="`marginTop: ${marginTop}`">
          <li class="h" v-for="(item, index) in news" :key="index">
            <img class="avatar" :src="item.src" />
            <span>{{ `${item.nickname} 邀请了1位好友获得 ${item.awardAmount} 元`}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="empty-block" v-else></div>
  </LayoutContainer>
</template>

<script>
import { inviteAwardBroadcast } from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'kaer-news-broadcast',
  props: {
    componentId: String,
    props: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      current: 1,
      marginTop: 0,
      animate: true,
      news: []
    };
  },
  computed: {
    ...mapState({
      pageData: state => state.share.pageData
    })
  },
  created() {
    this.getList();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    showMarquee: function() {
      const total = this.news.length;
      this.timer = setInterval(() => {
        if (this.current >= total) {
          this.current = 1;
          this.animate = false;
          this.$nextTick(() => { this.marginTop = 0; });
        } else {
          this.animate = true;
          this.$nextTick(() => { this.marginTop = `${-32 * (this.current - 1)}px`; });
          this.current++;
        }
      }, 2000);
    },
    async getList() {
      const req = {
        bizId: 'C_TERMINAL',
        activityId: this.pageData.activityId
      };
      const res = await inviteAwardBroadcast(req);
      this.news = res.map(item => {
        return {
          ...item,
          src: item.picture || require('@/assets/avatar.png')
        };
      });
      this.news.length && this.news.push(this.news[0]);
      this.showMarquee();
    }
  }
};
</script>

<style scoped lang="less">
.news-container {
  width: 100%;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16Px;
  padding: 0 4Px;

  .news-cot {
    height: 32Px;
    overflow: hidden;
    line-height: 32Px;

    .marquee_top {
      transition: all ease-in-out 0.5s;
      margin-top: 0;
    }

    .h {
      color: #fff;
      font-size: 12Px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      display: flex;
      align-items: center;

      .avatar {
        display: inline-block;
        width: 24Px;
        height: 24Px;
        border-radius: 50%;
        vertical-align: middle;
      }

      span {
        display: inline-block;
        margin-left: 8Px;
      }
    }
  }
}

.empty-block {
  height: 32Px;
}
</style>
